import cn from 'classnames';
import Popup from '../controls/Popup';
import { PopupBody } from '../controls/PopupBody';
import { PopupFooter } from '../controls/PopupFooter';

interface ConfirmProps {
    title?: string;
    text: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonDangerStyle?: boolean;
    disabled?: boolean;
    renderInBody?: boolean;
    onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onCancel: () => void;
}

export function Confirm({
    title,
    text,
    confirmButtonText = 'Confirm',
    cancelButtonText = 'Cancel',
    confirmButtonDangerStyle = false,
    disabled = false,
    renderInBody,
    onConfirm,
    onCancel,
}: ConfirmProps) {
    const handleClose = () => {
        if (!disabled) {
            onCancel();
        }
    };

    return (
        <Popup renderInBody={renderInBody} modalClass="modal-confirmation" title={title || 'Confirmation'} onClose={handleClose}>
            <PopupBody>
                <p className="status-message alert">
                    <i className="icon icon-warning" />
                    <span className="status-message-cnt">
                        {text}
                    </span>
                </p>
            </PopupBody>
            <PopupFooter>
                <button
                    type="button"
                    className="btn btn-ghost"
                    disabled={disabled}
                    onClick={handleClose}
                >
                    {cancelButtonText}
                </button>
                <button
                    type="button"
                    className={cn('btn', 'btn-main', { 'btn-danger': confirmButtonDangerStyle })}
                    disabled={disabled}
                    onClick={onConfirm}
                >
                    {confirmButtonText}
                </button>
            </PopupFooter>
        </Popup>
    );
}
